/* 🤖 this file was generated by svg-to-ts */
export const matIconRollerShades: {
  name: 'roller-shades';
  data: string;
} = {
  name: 'roller-shades',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20 19V3H4v16H2v2h20v-2h-2zM18 5v6H6V5h12zM6 19v-6h5v1.82A1.746 1.746 0 0 0 12 18a1.746 1.746 0 0 0 1-3.18V13h5v6H6z"/></svg>`
};
